import React from 'react'
import Button from './Button'

const ButtonCircleAdd = (props) => {
  return (
    <Button
      icon="AddCircleOutline"
      {...props}
    />
  )
}

export default ButtonCircleAdd
